export default __webpack_public_path__ + "static/media/dashboard-icon.52810de4.svg";